import { Tooltip } from '@mui/material';
import { FC } from 'react';
import { DeliveryContent } from 'api/models/Deliveries';
import { useContentsConfig } from 'hooks/useContentsConfig';
import { DeliveryContentsTextContainer } from './DeliveryContentsText.styles';

const DeliveryContentsText: FC<{
  variant?: 'icon' | 'text' | 'text-only';
  contents?: DeliveryContent;
  showNotSpecifiedText?: boolean;
}> = ({ variant = 'icon', contents = DeliveryContent.Default, showNotSpecifiedText = true }) => {
  const { label, Icon } = useContentsConfig(contents, showNotSpecifiedText);
  const icon = <Icon style={{ width: 20, height: 20 }} />;

  if (variant === 'icon') {
    return (
      <Tooltip arrow title={label}>
        {icon}
      </Tooltip>
    );
  }

  return (
    <DeliveryContentsTextContainer>
      {variant != 'text-only' && icon}
      <span>{label}</span>
    </DeliveryContentsTextContainer>
  );
};

export default DeliveryContentsText;
